import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const API_BASE_URL = process.env.NEXT_PUBLIC_API_BASE_URL;

export const finerworksApi = createApi({
  reducerPath: "finerworksApi",
  baseQuery: fetchBaseQuery({
    baseUrl: API_BASE_URL,
    credentials: "include",
    prepareHeaders: (headers) => {
      const token = localStorage.getItem("accessToken");
      if (token) {
        headers.set("authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),
  tagTypes: ["FinerworksInventory"],
  endpoints: (builder) => ({
    getFinerworksInventory: builder.query<any, any>({
      query: (params) => ({
        url: "/finerworks/inventory/list",
        method: "POST",
        body: params,
      }),
      providesTags: ["FinerworksInventory"],
    }),
    setFinerworksMarkup: builder.mutation<
      void,
      {
        sku: string;
        markupAmount: number;
        sellingPrice: number;
        markupType: "flat" | "fixed_price";
      }[]
    >({
      query: (body) => ({
        url: "/finerworks/inventory/set-markup",
        method: "POST",
        body,
      }),
      invalidatesTags: ["FinerworksInventory"],
    }),
  }),
});

export const {
  useGetFinerworksInventoryQuery,
  useSetFinerworksMarkupMutation,
} = finerworksApi;
